import client from "../Client/HttpClient";
import { IStatesModel } from "@/interfaces/modules";
const ApiPath = "SystemStates";

export default {
  GetStates: (): Promise<IStatesModel[]> => client.get(`${ApiPath}`),
  GetStatesById: (data: IStatesModel): Promise<IStatesModel> =>
    client.get(`${ApiPath}/${data.Id}`),
  PostStates: (data: IStatesModel): Promise<IStatesModel> =>
    client.post(`${ApiPath}`, data),
};
